import { ROUTE_PATH } from 'constants/routePath';
import useAuth from 'hooks/useAuth';
import { Navigate } from 'react-router-dom';

export type TProps = {
  children: React.ReactNode;
};

const RequiredGuest = ({ children }: TProps) => {
  const { isLogin: isLoginStorage } = useAuth();

  if (isLoginStorage && isLoginStorage?.isLogin) {
    return <Navigate replace to={ROUTE_PATH.common.HOME} />;
  }

  return <>{children}</>;
};

export default RequiredGuest;
